module.exports = __webpack_public_path__ + "img/39_37.416e79ce.png";